/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react'
import toast, { Toast } from 'react-hot-toast'
import { useLastUnreadChat, useOtherProfilesLookup } from '../../../state/hooks/ProfileDataHooks'
import FriendsChatModal from '../../modals/Friends/Chat/FriendsChatModal'
import './ChatMessageToast.scss'

const createCustomToast = (message: string, name: string, avatar: string, clickCallback: () => void, t: Toast) : any =>
{
    return (
        <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} custom-toast mvp-box`}>
            <div className="flex-1 w-0 p-4" onClick={() => { toast.dismiss(t.id); clickCallback()}}>
                <div className="flex items-start">
                    <div className="flex-shrink-0 pt-0.5">
                        <img className="avatar" src={avatar} alt="avatar" />
                    </div>
                    <div className="ml-3 flex-1">
                        <p className="name">{name}</p>
                        <p className="message">{message}</p>
                    </div>
                </div>
            </div>
            <div id="close-button-container">
                <button type='button' onClick={() => toast.dismiss(t.id)}>
                Close
                </button>
            </div>
        </div>
    )
}

export default () =>
{
	const { lastUnreadChat, setLastUnreadChat } = useLastUnreadChat()
    const profiles = useOtherProfilesLookup()
    

	useEffect(() => {
        if (lastUnreadChat){
            const from = profiles[lastUnreadChat.fromId]
            if (from){
                const clickCallback = () => {
                    FriendsChatModal.Show(from)
                }
                toast.custom((t) => {
                    return createCustomToast(lastUnreadChat.message, from.info.name, from.info.avatar, clickCallback, t)
                })
            }
            setLastUnreadChat(undefined)
        }
	}, [lastUnreadChat])

	return (
    <>
    </>
	)
}